module.exports = __webpack_public_path__ + "5ee7cf84549931012bb0c5303efb2c70.png";